import React from 'react';
import { Tooltip, HideEvent, Place, ShowEvent, TooltipVariant } from '@lux/tooltip';
import { TranslateScope, useTranslate } from '@pegasus/translation';
import { ComplementaryColor } from '@lux/tokens';
import { track } from '../../../lib/tracking';
import { isMobile } from '../../../lib/screenSize';
const tooltipMobileConfig = {
    hideEvent: HideEvent.NONE,
};
const tooltipDesktopConfig = {
    hideEvent: HideEvent.CLICK,
    autoHideIn: 15000,
};
const noop = () => { };
const AutoLoginTooltip = ({ children, firstName, onDismiss = noop, onShow = noop, autoShowIn = 500, }) => {
    const translate = useTranslate();
    const handleShow = () => {
        track('tooltip_shown');
        onShow();
    };
    const handleDismiss = (byUser) => {
        if (byUser) {
            track('tooltip_CTA_click');
        }
        else {
            track('tooltip_closed');
        }
        onDismiss();
    };
    const _isMobile = isMobile();
    return (React.createElement(Tooltip, { place: Place.BOTTOM, showEvent: ShowEvent.NONE, dismissText: translate('autoLoginTooltip.dismiss'), content: translate('autoLoginTooltip.text'), heading: translate('autoLoginTooltip.title', { name: firstName }), variant: TooltipVariant.CLICKME, backgroundColor: ComplementaryColor.brand30, autoShowIn: autoShowIn, onDismiss: handleDismiss, onShow: handleShow, ...(_isMobile ? tooltipMobileConfig : tooltipDesktopConfig), 
        /**
         * Documentation about offset: https://popper.js.org/docs/v2/modifiers/offset/
         */
        tippyProps: { offset: [_isMobile ? -55 : -10, 0] } }, children));
};
export const AutoLoginTooltipWrapper = ({ children, firstName, onDismiss, onShow, autoShowIn, }) => {
    return (React.createElement(TranslateScope, { path: "" },
        React.createElement(AutoLoginTooltip, { firstName: firstName, onDismiss: onDismiss, onShow: onShow, autoShowIn: autoShowIn }, children)));
};
//# sourceMappingURL=tooltip.js.map